__turbopack_context__.v({
  "arrow": "Peer-module-scss-module__9ENEQa__arrow",
  "arrowDown": "Peer-module-scss-module__9ENEQa__arrowDown",
  "arrowUp": "Peer-module-scss-module__9ENEQa__arrowUp",
  "peerWrapper": "Peer-module-scss-module__9ENEQa__peerWrapper",
  "tableData": "Peer-module-scss-module__9ENEQa__tableData",
});
